import ChefBlogDishItem from './ChefBlogDishItem'

export default ChefBlogDishItem



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/components/ChefBlogDishItem/index.js